import { Button, Center, Loader, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { LoginStatus } from '@/entities/user/user';
import { useAuthSession } from '@/entities/user/session';

export function ApplicationPreparation({
  onRetry,
  onLogout,
  fullScreen = false,
}: {
  onRetry: () => void;
  onLogout: () => void;
  fullScreen?: boolean;
}) {
  const { t } = useTranslation();
  const { loginStatus } = useAuthSession();
  const failed = loginStatus === LoginStatus.preparationError;

  return (
    <Center
      mih={fullScreen ? '100dvh' : 260}
      data-testid='application-preparation'
    >
      <Stack align='center' gap='sm' maw={440} role='status' aria-live='polite'>
        {failed ? (
          <>
            <Text fw={500}>{t('app.storagePrefetch.errorTitle')}</Text>
            <Text c='dimmed' size='sm' ta='center'>
              {t('app.storagePrefetch.errorDescription')}
            </Text>
            <Button
              data-testid='preparation-retry'
              variant='filled'
              onClick={onRetry}
            >
              {t('action.retry')}
            </Button>
            <Button data-testid='preparation-logout' onClick={onLogout}>
              {t('oidcCallback.backToLogin', { ns: 'login' })}
            </Button>
          </>
        ) : (
          <>
            <Loader aria-hidden='true' />
            <Text c='dimmed'>{t('app.storagePrefetch.loading')}</Text>
          </>
        )}
      </Stack>
    </Center>
  );
}
